import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import React, { useState } from "react";
import styles from "styles/component/DraggableList.module.scss";

const filterTeeTypes = createFilterOptions();

const filterWithAddNew = (options, state) => {
  const filtered = filterTeeTypes(options, state);
  const typed = state.inputValue.trim();
  if (typed !== "" && filtered.length === 0) {
    return [{ id_courseTeeType: null, name: typed, isAddNew: true }];
  }
  return filtered;
};

const getOptionLabel = (option) => option?.name ?? "";

const isSameOption = (option, value) => option.id_courseTeeType === value.id_courseTeeType;

function TeeTypeSelect({ options, selectedId, onSelect, onCreate }) {
  const [creating, setCreating] = useState(false);
  const selected = options.find((option) => option.id_courseTeeType === selectedId) ?? null;
  const [inputValue, setInputValue] = useState(getOptionLabel(selected));

  const handleChange = async (_, option) => {
    if (!option) return;
    if (!option.isAddNew) {
      onSelect(option);
      return;
    }
    setCreating(true);
    const created = await onCreate(option.name);
    setCreating(false);
    if (created) {
      onSelect(created);
    } else {
      setInputValue(getOptionLabel(selected));
    }
  };

  const renderOption = ({ key, className, ...liProps }, option) => (
    <li
      {...liProps}
      key={option.isAddNew ? "add-new" : option.id_courseTeeType}
      className={`${className} ${option.isAddNew ? styles.addNewOption : ""}`}
    >
      {option.isAddNew ? `Add New Tee Type: "${option.name}"` : option.name}
    </li>
  );

  const renderInput = (params) => (
    <TextField
      {...params}
      placeholder="Select tee type"
      inputProps={{ ...params.inputProps, tabIndex: -1 }}
    />
  );

  return (
    <Autocomplete
      className={styles.teeTypeSelect}
      options={options}
      value={selected}
      inputValue={inputValue}
      onInputChange={(_, value) => setInputValue(value)}
      onChange={handleChange}
      filterOptions={filterWithAddNew}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isSameOption}
      renderOption={renderOption}
      renderInput={renderInput}
      ListboxProps={{ className: styles.teeTypeListbox }}
      disabled={creating}
      disableClearable
      autoHighlight
      selectOnFocus
      handleHomeEndKeys
      size="small"
    />
  );
}

TeeTypeSelect.defaultProps = {
  options: [],
  selectedId: undefined,
  onSelect: () => {},
  onCreate: async () => null,
};

export default TeeTypeSelect;
